import {DataStatus} from 'platform/components';

import {useGetTestDriveCalendarSettingsQuery} from '@dms/api/sales';
import {BranchResponseBody} from '@dms/api/shared';

import {TestIdProps} from 'shared/web';

import {useTestDriveCalendarSettingsSubmit} from '../hooks/useTestDriveCalendarSettingsSubmit';
import {TestDriveCalendarSettingsForm} from './TestDriveCalendarSettingsForm';

interface TestDriveCalendarSettingsDialogProps extends TestIdProps {
  assignedBranches: BranchResponseBody[];
}

export function TestDriveCalendarSettingsDialog(props: TestDriveCalendarSettingsDialogProps) {
  const {data, isLoading, isError} = useGetTestDriveCalendarSettingsQuery();
  const {submit, isLoading: isSubmitting} = useTestDriveCalendarSettingsSubmit();

  return (
    <DataStatus isLoading={isLoading} isError={isError} minHeight={25}>
      <TestDriveCalendarSettingsForm
        defaultValues={data ?? {}}
        assignedBranches={props.assignedBranches}
        onSubmit={submit}
        isSubmitting={isSubmitting}
        data-testid={props['data-testid']}
      />
    </DataStatus>
  );
}
